/** @file effectFrameRect: the sheet rect of an effect strip's frame after some seconds. */
import type { EffectFrames } from '@zilo/pose3d-format/types/drawable';

/** `i = floor(elapsed fps + 1e-6)`; looping -> `i mod count`; one-shot past the last frame -> null; `[ox + i w, oy, w, h]`. */
export function effectFrameRect(frames: Omit<EffectFrames, 'sheet'>, elapsed: number): [number, number, number, number] | null {
  const raw = Math.floor(Math.max(0, elapsed) * frames.fps + 1e-6);
  const i = frames.loop ? raw % frames.count : raw;
  if (i >= frames.count) return null;
  const [w, h] = frames.size;
  return [frames.origin[0] + i * w, frames.origin[1], w, h];
}
